import React, { useEffect, useRef } from "react"
import {
  categoryFields,
  detailFields,
} from "src/modules/app_sigo/constants/fields"
import { MyForm, MyModal, MyUI } from "src/core/components"
import { useForceUpdate } from "src/modules/app_sigo/hooks/useForceUpdate"
import { HLink, HUtils } from "src/core/helpers"
import { SGPaths } from "src/modules/app_sigo/constants/paths"
import styled from "styled-components"
import classnames from "classnames"
import { showAlert } from "src/modules/app_sigo/helpers/ui"
import Skeleton from "react-loading-skeleton"
import { Button } from "reactstrap"
import { MdOutlineClose } from "react-icons/md"
import classNames from "classnames"

const MyUIBookingInfo = props => {
  const { data = {}, loading, moreData, fnList, isAuthenticated } = props
  const [keyBookingUI, forceUpdateBooking] = useForceUpdate()
  const refTopForm = useRef<MyForm>(null)
  const rentalPrice = data?.[categoryFields.fRentalPriceByDay]
  const rentalPriceOriginal = data?.[categoryFields.fRentalPriceByDayOriginal]
  const deliveryAddress = data?.[detailFields.fDeliveryAddress]
  const deliveryInfo = data?.[detailFields.fDeliveryInfo]
  const total = data?.[detailFields?.fTotalPrice]
  const canBooking = data?.[detailFields.fCanBooking]

  const getTimeNearstGreater = (time: any, arrTime = [] as any) => {
    let timeNear = 0

    arrTime?.forEach(item => {
      if (time < item && (item < timeNear || !timeNear)) {
        timeNear = item
      }
    })
    return timeNear
  }

  const arrDayDisabled = [
    // 1720976400000, 1721062800000, 1722186000000, 1722445200000,
  ]
  const configFormBooking: any = {
    defaultValues: {
      ...data,
      DateFromTo: [
        data?.[categoryFields.fFromDate],
        data?.[categoryFields.fToDate],
      ],
    },
    controls: [
      {
        label: "",
        fieldName: "DateFromTo",
        type: "input_date_from_to_detail",
        more: {
          morePropsDateFlatPickr: {
            calendarStartDay: 0,
            arrDayDisabled: arrDayDisabled,
            // isShowPopup: true,
            notClickOutSide: true,
          },
          moreOptionsDateFlatPickr: {
            disable: [
              function (date) {
                return (
                  date < new Date().setHours(0, 0, 0, 0) &&
                  date.getTime() !== new Date().setHours(0, 0, 0, 0)
                )
              },
            ],
          },
          configMergeText: {
            titleWhenMergeText: "Chọn ngày",
          },
          mappingField: {
            fFrom: categoryFields.fFromDate,
            fTo: categoryFields.fToDate,
          },
          configSelectTime: {
            titleTimeFrom: "Giờ nhận xe",
            titleTimeTo: "Giờ trả xe",
          },
          configSelectDate: {
            titleDatePicker: "Chọn ngày",
            descriptionPicker: "Chọn ngày để biết giá chính xác của lịch trình",
            placeholderTo: "Chọn ngày trả",
            placeholderFrom: "Chọn ngày nhận",
            breakCharacter: "-ngày ",
            labelFrom: "Ngày nhận",
            labelTo: "Ngày trả",
          },
          classNameGroup: "w-100 datefromto",
        },
      },
      // {
      //   label: "NHẬN XE",
      //   fieldName: categoryFields.fFromDate,
      //   type: "input_datetime_v2",
      //   more: {
      //     classNameGroup: "col-6 checkin-time",
      //     configDate: {
      //       minDate: new Date(),
      //       placeholderDate: "Thêm ngày",
      //     },
      //     configTime: {
      //       placeholderTime: "Chọn giờ",
      //     },
      //     configSelectTime: {
      //       labelTime: "Giờ nhận xe",
      //     },
      //   },
      // },
      // {
      //   label: "TRẢ XE",
      //   fieldName: categoryFields.fToDate,
      //   type: "input_datetime_v2",
      //   more: {
      //     classNameGroup: "col-6 checkout-time",
      //     configDate: {
      //       minDate: new Date(data?.[categoryFields.fFromDate]),
      //       placeholderDate: "Thêm ngày",
      //     },
      //     configTime: {
      //       placeholderTime: "Chọn giờ",
      //     },
      //     configSelectTime: {
      //       labelTime: "Giờ trả xe",
      //     },
      //   },
      // },
      // {
      //   label: "ĐỊA ĐIỂM GIAO XE",
      //   fieldName: "fbtn",
      //   type: "button_modal_form",
      //   more: {
      //     classNameGroup: "col-12 change-address",
      //     configBtn: {
      //       name: deliveryAddress,
      //       className: "",
      //       disabled: !data?.[detailFields.fCanChangeDeliveryAddress],
      //     },
      //     configModal: {
      //       title: "Địa điểm giao xe",
      //       size: "default",
      //       showFooter: true,
      //       // showFooterClose: true,
      //       showFooterOK: true,
      //       // colorBtnClose: "den",
      //       // titleBtnClose: "Hủy bỏ",
      //       titleBtnOK: "Lưu lại",
      //       className: "footer-space-between modal-filter default",
      //     },
      //     configModalForm: {
      //       needFormatData: true,
      //       fieldsInGroup: [
      //         categoryFields.fDeliveryAddress,
      //         categoryFields.fLongitude,
      //         categoryFields.fLatitude,
      //       ],
      //       formatData: obj => {
      //         let myObj = obj
      //         if (obj?.[`${categoryFields.fDeliveryAddress}_MoreInfo`]) {
      //           const location = HUtils.get(
      //             obj,
      //             `${categoryFields.fDeliveryAddress}_MoreInfo[0].geometry.location`
      //           )
      //           if (location?.lat) {
      //             myObj[categoryFields.fLatitude] = location.lat()
      //           }
      //           if (location?.lng) {
      //             myObj[categoryFields.fLongitude] = location.lng()
      //           }
      //         }
      //         return myObj
      //       },
      //       getConfigForm: () => {
      //         return {
      //           controls: [
      //             {
      //               label:
      //                 "Bạn có thể thay đổi địa chỉ giao nhận xe của mình tại đây",
      //               fieldName: categoryFields.fDeliveryAddress,
      //               type: "input_address",
      //               more: {
      //                 morePropsInputAddress: {
      //                   mappingFields: {
      //                     fieldAddress: categoryFields.fDeliveryAddress,
      //                   },
      //                   props4Search: {
      //                     configSelect: {
      //                       placeholder: "Địa chỉ giao xe",
      //                     },
      //                   },
      //                 },
      //               },
      //             },
      //           ],
      //         }
      //       },
      //     },
      //     styleLabel: {
      //       fontWeight: 700,
      //     },
      //   },
      // },
      // {
      //   label: (
      //     <div className="diachixe mb-10px">
      //       <i
      //         className="flaticon-location-1 pull-left"
      //         style={{
      //           fontSize: 30,
      //           marginRight: 10,
      //           paddingTop: 10,
      //         }}
      //       />
      //       <span>{deliveryAddress}</span>
      //     </div>
      //   ),
      //   fieldName: "addressTxt",
      //   type: "only_label",
      // },
    ],
  }
  const rentalPriceDetails = data?.[detailFields.fRentalPriceDetails] || []
  const vouchers = data?.[detailFields.fVouchers] || []
  const bookingInfoItems = data?.[detailFields.fBookingInfoItems]

  const getShowPrice = () => {
    const dateFrom = data?.[categoryFields.fFromDate]
    const dateTo = data?.[categoryFields.fToDate]
    if (!rentalPrice && !dateFrom && !dateTo) {
      return false
    }
    return true
  }
  const renderPrice = () => {
    const canShow = getShowPrice()
    return (
      <>
        <div className="mb-20px">
          {canShow ? (
            <>
              <span className="txtgia">
                <span className=" main">{rentalPrice}</span>/ngày
                &nbsp;&nbsp;&nbsp;
              </span>
              {rentalPriceOriginal && rentalPrice !== rentalPriceOriginal && (
                <del style={{ marginRight: 10 }} className="giacu ">
                  {rentalPriceOriginal}
                </del>
              )}
            </>
          ) : (
            <span className="txtgia">
              <span className="main">Chọn ngày để biết giá</span>
            </span>
          )}
        </div>
      </>
    )
  }
  const renderBookingInfo = () => {
    return (
      <div className="w divitem">
        <MyForm
          key={keyBookingUI}
          ref={refTopForm}
          className="d-flex flex-wrap check-in-out-time"
          configForm={configFormBooking}
          fnList={
            {
              afterUpdateValueControl: opts => {
                const { fieldName, newValue } = opts
                let needReload = false
                let values = {
                  [fieldName]: newValue,
                }
                // let newData: any = JSON.parse(JSON.stringify(data))
                if (fieldName === "DateFromTo") {
                  return
                  // const [start, end] = newValue
                  // newData[categoryFields.fFromDate] = start
                  // newData[categoryFields.fToDate] = end
                  // newData[fieldName] = newValue
                  // if (
                  //   newData?.[categoryFields.fFromDate] &&
                  //   newData?.[categoryFields.fToDate]
                  // ) {
                  //   fnList.updateData(newData, {
                  //     needReloadUI: false,
                  //     notRequestUpdate: true,
                  //   })
                  // }
                } else fnList.updateData(values, { needReloadUI: needReload })
              },
              afterUpdateMultiValues: obj => {
                if (
                  obj?.[categoryFields.fDeliveryAddress] !==
                  data?.[categoryFields.fDeliveryAddress]
                ) {
                  if (fnList?.updateMoreData) {
                    fnList.updateMoreData({
                      isAddressChanged: true,
                    })
                    setTimeout(() => {
                      if (fnList?.updateData) {
                        fnList.updateData(obj)
                      }
                    }, 100)
                  }
                }
              },
              afterCloseSelectTime: value => {
                let newData: any = JSON.parse(JSON.stringify(data))
                fnList.updateData(newData, {
                  needReloadUI: true,
                  notRequestUpdate: true,
                })
              },
              afterSaveSelectTime: value => {
                let [start, end] = value
                let newData: any = JSON.parse(JSON.stringify(data))

                if (start && end && end > start) {
                  newData["FromDate"] = start
                  newData["ToDate"] = end
                  newData["DateFromTo"] = value
                }

                let needFormatValue = false
                if (!start && !end) {
                  const { ToDate, FromDate } = data
                  start = FromDate
                  end = ToDate
                  needFormatValue = true
                }
                // Chỉ format khi chưa chọn thời gian trả và khi thời gian thuê > = thời gian trả
                if (!end || start >= end || !start) {
                  needFormatValue = true
                }
                if (needFormatValue) {
                  let _newToDate = start + 86400000
                  let _newFromDate = end - 86400000
                  let endHours = new Date(start).getHours()
                  let endMinute = new Date(start).getMinutes()
                  let startHours = new Date(end).getHours()
                  let startMinute = new Date(end).getMinutes()

                  if (start >= end && end && start) {
                    endHours = new Date(end).getHours()
                    endMinute = new Date(end).getMinutes()
                    _newToDate = new Date(
                      new Date(_newToDate).setHours(endHours, endMinute, 0, 0)
                    ).getTime()
                    const nearestGreater = getTimeNearstGreater(
                      start,
                      arrDayDisabled
                    )
                    if (nearestGreater && _newToDate > nearestGreater) {
                      const dateGreater = new Date(nearestGreater)
                      dateGreater.setDate(dateGreater.getDate() - 1)
                      dateGreater.setHours(23, 30, 0, 0)
                      _newToDate = dateGreater.getTime()
                    }

                    newData[categoryFields.fToDate] = _newToDate
                    newData[categoryFields.fFromDate] = start
                    newData["DateFromTo"] = [start, _newToDate]
                  }

                  if (!end && start) {
                    _newToDate = new Date(
                      new Date(_newToDate).setHours(endHours, endMinute, 0, 0)
                    ).getTime()
                    const nearestGreater = getTimeNearstGreater(
                      start,
                      arrDayDisabled
                    )
                    if (nearestGreater && _newToDate > nearestGreater) {
                      const dateGreater = new Date(nearestGreater)
                      dateGreater.setDate(dateGreater.getDate() - 1)
                      dateGreater.setHours(23, 30, 0, 0)
                      _newToDate = dateGreater.getTime()
                    }
                    newData[categoryFields.fToDate] = _newToDate
                    newData[categoryFields.fFromDate] = start
                    newData["DateFromTo"] = [start, _newToDate]
                  }

                  if (!start && end) {
                    _newFromDate = new Date(
                      new Date(_newFromDate).setHours(
                        startHours,
                        startMinute,
                        0,
                        0
                      )
                    ).getTime()
                    newData[categoryFields.fFromDate] = _newFromDate
                    newData[categoryFields.fToDate] = end
                    newData["DateFromTo"] = [_newFromDate, end]
                  }
                }
                fnList.updateData(newData, {
                  needReloadUI: true,
                })
              },
              updateDataToView: (value, { cbSuccess, cbError }) => {
                let [start, end] = value
                let newData: any = JSON.parse(JSON.stringify(data))
                if (!start || !end) {
                  return
                }
                newData["FromDate"] = start
                newData["ToDate"] = end
                newData["DateFromTo"] = value
                fnList.updateDataToView &&
                  fnList.updateDataToView(newData, { cbSuccess, cbError })
              },
            } as any
          }
          renderFooter={() => <></>}
        />
        <div className="change-address">
          <label className="label-control">ĐỊA ĐIỂM GIAO XE</label>
          <button
            className="btn btn-secondary"
            disabled={!data?.[detailFields.fCanChangeDeliveryAddress]}
            onClick={() => {
              if (data?.[detailFields.fCanChangeDeliveryAddress] !== true) {
                return
              }
              MyModal.showFromMyUI(
                {
                  type: "sg_vehicle_delivery_adress",
                  data: data,
                  fnList: {
                    fnUpdateDelivery: obj => {
                      if (obj) {
                        let _newDeliveryInfo = obj[detailFields.fDeliveryInfo]
                        if (obj[detailFields.fDeliveryInfo]) {
                          let objUpdate = {}
                          if (_newDeliveryInfo.IsUserTakeSelected) {
                            objUpdate = {
                              [detailFields.fDeliveryAddress]: null,
                              [detailFields.fLatitude]: null,
                              [detailFields.fLongitude]: null,
                            }
                          } else {
                            objUpdate = {
                              [detailFields.fDeliveryAddress]:
                                _newDeliveryInfo.OwnerShipDeliveryAddress,
                              [detailFields.fLatitude]:
                                _newDeliveryInfo.OwnerShipLat,
                              [detailFields.fLongitude]:
                                _newDeliveryInfo.OwnerShipLng,
                            }
                          }
                          objUpdate[detailFields.fDeliveryInfo] =
                            obj[detailFields.fDeliveryInfo]
                          fnList?.updateData && fnList.updateData(objUpdate)
                        }
                        MyModal.hideModalMyUI()
                      }
                    },
                  },
                },
                {
                  title: "Địa điểm giao xe",
                  size: "default",
                  modalClassName:
                    "default modal-filter modal-dialog-scrollable-new",
                  modalScrollInside: true,
                }
              )
            }}
          >
            {deliveryAddress ? deliveryAddress : "Chọn địa điểm giao xe"}
          </button>
        </div>
      </div>
    )
  }
  const renderInsurance = () => {
    return (
      <>
        <div className="divitem">
          <div className="title-xanh">Bảo hiểm</div>
          <p>
            Chuyến đi được bảo hiểm bởi VNI.{" "}
            <span
              className="btn-link"
              onClick={() => {
                MyModal.showFromMyUI(
                  { type: "sg_comming_soon" },
                  { title: "Thông Tin Bảo Hiểm", size: "lg" }
                )
              }}
            >
              Tìm hiểu thêm
            </span>
          </p>
          <div className="clearfix"></div>
        </div>
      </>
    )
  }
  const renderPriceDetails = () => {
    return (
      <MyUI
        type="sg_price_details"
        data={data}
        fnList={fnList}
        forceUpdateBooking={forceUpdateBooking}
        isAuthenticated={isAuthenticated}
        canEditVoucher={true}
      />
    )
  }
  const renderBooking = () => {
    return (
      <>
        <div className="divitem">
          <button
            className="btncheckout btn btn-primary btn-lg btn-block"
            disabled={!canBooking}
            onClick={() => {
              fnList?.requestSaveLogUserClickBooking &&
                fnList?.requestSaveLogUserClickBooking()
              if (fnList?.onOpenBookingConfirm) {
                fnList?.onOpenBookingConfirm()
              }
              // MyModal.showFromMyUI(
              //   {
              //     type: "sg_confirm_booking",
              //     data: data,
              //     msg: moreData?.msg4Owner,
              //     fnList: {
              //       updateValue: v => {
              //         if (fnList?.updateMoreData) {
              //           fnList.updateMoreData({
              //             msg4Owner: v,
              //           })
              //         }
              //       },
              //       onBooking: fnList?.booking,
              //       afterBooking: () => {
              //         MyModal.hideModalMyUI()
              //         showAlert({
              //           component: (
              //             <MyUI
              //               type="alert"
              //               alertType="success"
              //               title="Đang chờ xác nhận"
              //               msg="Cảm ơn bạn đã cho Sigo cơ hội được phục vụ. Kết quả đặt xe sẽ được chủ xe phản hồi - Chỉ thanh toán khi chuyến đi ở trạng thái “Chờ đặt cọc”."
              //             />
              //           ),
              //         })
              //         HLink.openUrl(SGPaths.chuyendicuatoi, "_self")
              //       },
              //       afterBookingFail: () => {
              //         // MyModal.hideModalMyUI()
              //       },
              //     },
              //   },
              //   {
              //     showHeader: false,
              //     showHeaderClose: true,
              //     size: "top",
              //   }
              // )
            }}
          >
            Đặt xe
          </button>
          {total && (
            <div className="not-yet-payment">Bạn vẫn chưa bị trừ tiền</div>
          )}
        </div>
        {/* {bookingInfoItems?.length > 0 &&
          bookingInfoItems.map((v, i) => {
            return (
              <div
                key={i}
                className={classnames(
                  "divitem ttcuoi",
                  i === bookingInfoItems.length - 1 ? "noneborder" : ""
                )}
              >
                <img src={v?.IconUrl} alt="" />
                <span>
                  <b> {v?.TitleLeft}</b>
                  <span className="pull-right">{v?.TitleRight}</span>
                </span>
                <p>{v?.Content}</p>
                <div className="clearfix"></div>
              </div>
            )
          })} */}
      </>
    )
  }
  const renderLoading = () => {
    return (
      <WrapLoading>
        <Skeleton height={"100%"} />
      </WrapLoading>
    )
  }
  if (loading) {
    return renderLoading()
  }
  return (
    <Wrap id="infosing" className="infosing">
      {renderPrice()}
      {renderBookingInfo()}
      {renderBooking()}
      {/* {renderInsurance()} */}
      {renderPriceDetails()}
    </Wrap>
  )
}
const WrapLoading = styled.div`
  height: 100px;
`
const Wrap = styled.div`
  &.infosing {
    box-shadow: 0px 3px 18px 5px #0000001a;
    border: 1px solid #ddd;
  }
  & .divitem {
    margin-bottom: 18px;
  }
  & .w {
    border: 1px solid #67676780;
    border-radius: 10px;
    & .label-control {
      font-weight: 600;
      color: var(--den);
      margin-bottom: 0 !important;
      font-size: 14px;
    }
    & .form-group {
      &.checkin-time {
        border-right: 1px solid #67676780;
      }
      &.checkin-time,
      &.checkout-time {
        margin-bottom: 0 !important;
        padding: 12px;
        border-bottom: 1px solid #67676780;
      }
      &.mb-10px {
        margin-bottom: 10px !important;
      }
    }
    & .mc-input-datetime {
      margin-top: -6px;
      flex-direction: row-reverse;
      & input,
      & .form-control {
        padding: 0px;
        padding-left: 4px;
        box-shadow: none !important;
      }
      & .mc-input-select-one {
        & .nice-select {
          padding-right: 5px;
        }
      }
      & .nice-select {
        font-size: 16px;
        padding: 0;
        display: flex;
        align-items: center;
        clear: none;
        border: none;
        border-radius: 0px;
        background: none !important;
        &:after {
          right: 0px;
          top: 0;
          margin: 0;
          content: "-";
          transform: none;
          border: none;
          transform-origin: none;
        }
      }
    }
    & .change-address {
      padding: 16px 12px;
      min-height: 86px;
      margin-bottom: 0px !important;
      & button {
        background: transparent !important;
        padding: 0;
        color: var(--mau1);
        border: 0 !important;
        box-shadow: none !important;
        font-size: 16px;
        text-align: left;
        color: #5f5d5d;
        width: 100%;
        position: relative;
        padding-right: 8px;
        text-wrap: wrap;
        white-space: normal;
        word-break: break-word;
        min-height: 23px;
        &:after {
          transform: translate(-2px, -50%) rotate(-45deg);
          width: 8px;
          height: 8px;
          top: 50%;
          right: 0;
          position: absolute;
          display: block;
          content: "";
          border-right: 1px solid #000;
          border-bottom: 1px solid #000;
        }
      }
    }
  }
  & .not-yet-payment {
    font-size: 14px;
    text-align: center;
    margin-top: 8px;
  }
  & .colctg {
    padding-bottom: 12px;
  }
  & .btnremovecoupon {
    box-shadow: none !important;
    border: 1px solid red !important;
    padding: 0;
  }
  & .ttcuoi {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
    & img {
      width: 40px;
      height: 100%;
      object-fit: contain;
      float: left;
      margin-right: 15px;
      vertical-align: middle;
      padding-top: 5px;
    }
    &.noneborder {
      border: none;
      margin-bottom: 0px;
    }
  }
  & .btncheckout {
    box-shadow: none !important;
    border: 1px solid transparent !important;
    font-weight: 600;
    font-size: 18px;
    background: var(--mau1);
  }
  & hr {
    boder: 1px solid #d9d9d9;
  }
  & .banggiactx {
    color: var(--den);
    & .title-xanh {
      margin-bottom: 35px;
    }
    & .column-left {
      text-decoration: underline;
    }
    & .has-details {
      & .tippy-box {
        padding: 0;
        border-radius: 18px;
        padding-top: 0;
        background-color: var(--color-text-fff);
        box-shadow: 0px 4px 10px 0px #00000040;
        max-width: unset !important;
        & .tippy-content {
          padding: 0;
        }
      }
      & .tippy-arrow {
        color: var(--color-text-fff);
        display: none;
      }
    }
  }
  & .btngiamgia {
    position: relative;
    background: transparent;
    border: none;
    width: 100%;
    text-align: left;
    padding: 16px 0 10px 0;
    color: var(--den);
    &:after {
      transform: translate(-2px, -50%) rotate(-45deg);
      width: 8px;
      height: 8px;
      top: 50%;
      right: 0;
      position: absolute;
      display: block;
      content: "";
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  }
  & .total-price {
    font-weight: bold;
  }
  & .diachixe {
    display: flex;
    align-items: flex-end;
  }
  & .input_datetime-dropdown-menu {
    transform: translate3d(-120px, 4px, 0px) !important;
    z-index: 1;
  }
  @media (max-width: 1500px) {
    & .input_datetime-dropdown-menu {
      transform: translate3d(-300px, 4px, 0px) !important;
    }
  }
  @media (max-width: 1199px) {
    & .input_datetime-dropdown-menu {
      transform: translate3d(-350px, 4px, 0px) !important;
    }
  }
  @media (max-width: 996px) {
    & .input_datetime-dropdown-menu {
      transform: translate3d(-100px, 4px, 0px) !important;
    }
    & .checkin-time {
      & .input_datetime-dropdown-menu {
        transform: translate3d(50px, 4px, 0px) !important;
      }
    }
  }
  @media (max-width: 767px) {
    & .checkin-time {
      & .input_datetime-dropdown-menu {
        transform: translate3d(-30px, -12px, 0px) !important;
      }
    }
    & .checkout-time {
      & .input_datetime-dropdown-menu {
        transform: translate3d(-180px, -12px, 0px) !important;
      }
    }
  }
`
export default MyUIBookingInfo
